import React from "react";
import Switch from "components/Switch";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { setAnonymizeUsers } from "slices/systemAdmin/actions/systemAdmin";
import {
  setWorkspacesSearchTerm,
  setRedirectedWorkspace,
} from "slices/systemAdmin/systemAdminSlice";
import SearchBar from "components/SearchBar/searchBar";
import InfoCard from "components/InfoCard";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { DELETE_WORKSPACE_BUTTON } from "constants/systemAdmin";
import { exportModalTypes } from "layout/systemAdmin/workspaces/modals/ExportReportModal";

const WorkspacesHeader = () => {
  const dispatch = useDispatch();
  const workspacesInfo = useSelector(
    (state) => state.systemAdmin.workspacesInfo
  );
  const searchTerm = useSelector((state) => state.systemAdmin.searchTerm);

  const anonymize = workspacesInfo?.anonymizeUsers;

  const handleAnonymizeChange = () => {
    if (anonymize) {
      dispatch(setAnonymizeUsers(false));
    } else {
      dispatch(showModal(modalTypes.ANONYMIZE_USERS));
    }
  };

  const getInfoMessage = () => {
    const multiUsers = [];

    workspacesInfo?.workspaces?.forEach((workspace) =>
      workspace.users.forEach((user) => {
        if (user.workspaces.length > 1) {
          multiUsers.push(user.username);
        }
      })
    );
    const uniqueUsers = [...new Set(multiUsers)].length;

    return uniqueUsers !== 0
      ? `There are ${
          workspacesInfo?.totalLicensedUsers
        } licensed users. ${uniqueUsers} of these ${
          uniqueUsers === 1 ? "is" : "are"
        } multi-workspace user${
          uniqueUsers === 1 ? "" : "s"
        } and will only take one license.`
      : undefined;
  };

  return (
    <div className="system_admin__header" data-testid="workspaces-header">
      <div className="system_admin__header__searchbar__container">
        <SearchBar
          searchMode={searchTerm !== ""}
          textFromProps={searchTerm}
          onSubmit={(term) => dispatch(setWorkspacesSearchTerm(term))}
          onClear={() => {
            dispatch(setWorkspacesSearchTerm(""));
            dispatch(setRedirectedWorkspace(""));
          }}
        />
      </div>
      <div className="system_admin__header__button_holder">
        <div className="system_admin__header__button_holder__export">
          <Button
            onClick={() =>
              dispatch(
                showModal(modalTypes.EXPORT_REPORT, {
                  exportType: exportModalTypes.usage,
                })
              )
            }
            variant={buttonVariants.borderless}
            content={<span>Export Usage Report</span>}
            dataTest={DELETE_WORKSPACE_BUTTON}
          />
        </div>
        <div className="system_admin__header__button_holder__anonymize">
          Anonymize Users
          <div>
            <Switch
              handleChange={handleAnonymizeChange}
              currentSwitchState={anonymize}
              id="anonymize-button"
            />
            {anonymize ? (
              <span className="active">
                <b>On</b>
              </span>
            ) : (
              <span>Off</span>
            )}
          </div>
        </div>
        <div className="system_admin__header__button_holder__info">
          <InfoCard
            right={
              <span className="system_admin__header__button_holder__info__text">
                Total License <br /> Count
              </span>
            }
            left={
              <span className="system_admin__header__button_holder__info__number">
                {workspacesInfo?.licenseCount}
              </span>
            }
          />
          <InfoCard
            right={
              <span className="system_admin__header__button_holder__info__text">
                Total Licensed
                <br /> Users
              </span>
            }
            left={
              <span className="system_admin__header__button_holder__info__number">
                {workspacesInfo?.totalLicensedUsers}
              </span>
            }
            info={getInfoMessage()}
          />
        </div>
      </div>
    </div>
  );
};

export default WorkspacesHeader;
